import { render } from "./TheFooter.vue?vue&type=template&id=eb57def0&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=eb57def0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb57def0"

export default script